// src/components/MultiSelect/MultiSelectStyles.js

import styled from 'styled-components'
import colors from '@settings/styleSettings'

export const Container = styled.div`
  width: 100%;
  position: relative;
`
export const OptionsContainer = styled.div`
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  max-height: 200px;
  overflow-y: auto;
  border: 1px solid #ccc;
  border-radius: 4px;
  background-color: #fff;
  border: 1px solid ${colors.softGray};
  border-radius: 12px;
  z-index: 10;
`

export const Option = styled.div`
  padding: 10px;
  cursor: pointer;
  &:hover {
    background-color: #f0f0f0;
  }
`
export const SearchInput = styled.input`
  width: 100%;
  padding: 5px;
  box-sizing: border-box;
  border: 1px solid #ccc;
  border-radius: 4px;
  margin-bottom: 5px;
`
export const Checkbox = styled.div`
  cursor: pointer;
  display: inline-block;
  width: 20px;
  height: 20px;
  background: ${(props) => (props.checked ? colors.primary : '')};
  border: ${({ state }) => (state ? 'none' : `1px solid ${colors.softGray}`)};
  border-radius: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
  align-content: center;
  margin-right: 5px;
  transition: all 150ms;
`
export const CheckedIcon = styled.div`
  cursor: pointer;
  color: ${colors.background};
  font-size: 16px;
`
export const InputContainer = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  cursor: pointer;
  max-width: 100%;
  position: relative;
`

export const Icon = styled.div`
  color: ${colors.strongGray};
  pointer-events: none;
  position: absolute;
  left: 16px;
  font-size: 20px;
`

export const SelectBox = styled.input`
  width: 100%;
  border: 1px solid ${colors.softGray};
  box-sizing: border-box;
  padding-left: ${(props) => (props.isOpen ? '48px' : '16px')};
  padding-right: ${(props) => (props.isOpen ? '16px' : '16px')};
  display: flex;
  align-items: center;
  vertical-align: baseline;
  border-radius: 12px;
  cursor: pointer;
  min-height: 48px;
  font-size: 16px;
  background-color: ${(props) => (props.disabled ? colors.grayBackground : colors.background)};
  &:hover {
    border-color: ${(props) => (props.disabled ? colors.softGray : colors.primary)};
  }
  &::placeholder {
    color: ${(props) => (props.isOpen || props.disabled ? colors.strongGray : colors.titleStrongBlack)};
    font-family: Circular-Std;
    font-size: 16px;
  }
`

export const DropdownIndicator = styled.div`
  color: ${colors.strongGray};
  position: absolute;
  display: flex;
  right: 16px;
`
